import moment from 'moment'

export const priceFormat = (price?: number | string | null, currency: string | null = 'CZK', zeroLabel?: string, emptyChar?: string, notAvailable?: boolean) => {
  return formatPrice({
    price: price,
    currency: currency,
    zeroLabel: zeroLabel,
    emptyChar: emptyChar,
    notAvailable: notAvailable
  })
}

export const formatPrice = (props: { price?: number | string | null, currency?: string | null, zeroLabel?: string, emptyChar?: string, notAvailable?: boolean }) => {
  return formatNumber({
    ...props,
    emptyChar: props.emptyChar ?? 'N/A',
    value: props.price,
    style: 'currency',
    currency: props.currency ?? 'CZK'
  }) as string
}

export const formatNumber = ({
  value,
  currency = 'CZK',
  zeroLabel = 'zdarma',
  emptyChar,
  notAvailable,
  ...numberOptions
}:
  {
    value?: number | string | null,
    currency?: string,
    zeroLabel?: string,
    emptyChar?: string | null,
    notAvailable?: boolean
  } & Intl.NumberFormatOptions) => {

  const numberValue = new Number(value) as any
  if (value === null || isNaN(numberValue))
    return emptyChar

  const empty = Math.abs(Math.round(numberValue * 100) / 100) === 0


  const options: Intl.NumberFormatOptions = {
    maximumFractionDigits: 0,
    style: 'currency',
    currency: currency,
    ...numberOptions
  }

  return (notAvailable ?? false)
    ? emptyChar
    : (empty
      ? zeroLabel
      : Intl.NumberFormat('cs-CZ', options).format(numberValue!))
}

export const dateTimeFormat = 'D.M.YYYY HH:mm'

export const formatDate = (date?: Date | null, format?: string) => {
  if (!date) return undefined

  return moment(new Date(date)).format(format ?? 'YYYY-MM-DD') as any
}

export const formatDateTime = (date: Date, forceFormat?: string) => {
  return formatDate(date, forceFormat ?? dateTimeFormat)
}


export const toDate = (date?: Date) => {
  if (!date) return undefined

  const result = new Date(date);
  result.setHours(0, 0, 0, 0)

  return result;
}

